import type { ApplicationManagerDetail } from '@repo/sdk/gen'
import { makeBreadcrumbFromCache } from '@repo/ui/components/query-breadcrumbs'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import i18n from '@/lib/i18n'
import { makeQueryKeys } from '@/query/query-keys'

// The crumb of the application stands on the layout, so the pages under it
// (the correction) keep it in their trail.
export const Route = createFileRoute(
	'/(private)/bando/$residenceId/domande/$submissionId'
)({
	staticData: {
		breadcrumb: ({ params, queryClient }) =>
			makeBreadcrumbFromCache<ApplicationManagerDetail>(
				queryClient,
				makeQueryKeys.applications.detail(
					params.residenceId ?? '',
					params.submissionId ?? ''
				),
				(application) =>
					i18n.t('admin-applications:detail.title', {
						protocol: application.protocol
					})
			)
	},
	component: () => <Outlet />
})
